import axiosInstance from "./httpInterceptor";

/**
 * Low-level API calls to the authentication endpoints
 */
const authApi = {
  login: async (email, password) => {
    try {
      const response = await axiosInstance.post("/auth/signin", { email, password });
      return response.data;
    } catch (error) {
      console.error("API Login Error:", error.response || error.message);
      throw error;
    }
  },

  register: async (userData) => {
    try {
      const response = await axiosInstance.post("/auth/signup", userData);
      return response.data;
    } catch (error) {
      console.error("API Register Error:", error.response || error.message);
      throw error;
    }
  },

  refreshToken: async (refreshToken) => {
    try {
      const response = await axiosInstance.post("/auth/refreshtoken", { refreshToken });
      return response.data;
    } catch (error) {
      console.error("API Refresh Token Error:", error.response || error.message);
      throw error;
    }
  },

  logout: async (userId) => {
    try {
      const response = await axiosInstance.post("/auth/logout", { userId });
      return response.data;
    } catch (error) {
      console.error("API Logout Error:", error.response || error.message);
      throw error;
    }
  },

  changePassword: (oldPassword, newPassword) => {
    return axiosInstance.post("/auth/change-password", { oldPassword, newPassword });
  },

  forgotPassword: async (email) => {
    try {
      const response = await axiosInstance.post("/auth/forgot-password", { email });
      return response.data;
    } catch (error) {
      console.error("API Forgot Password Error:", error.response || error.message);
      throw error;
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      const response = await axiosInstance.post("/auth/reset-password", {
        token,
        password: newPassword,
      });
      return response.data;
    } catch (error) {
      console.error("API Reset Password Error:", error.response || error.message);
      throw error;
    }
  },
};

export default authApi;
